import { Injectable } from '@angular/core';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class DateTimeService {
  constructor() {
  }
  timeIsEndAfterStart(startTime: string, endTime: string): boolean {
    return moment(endTime).isAfter(startTime);
  }
}
